export type StateOption = {
  id: string;
  label: string;
  value: string;
  field: string;
  LLC: number;
  Corporation: number;
  Nonprofit: number;
  formationFee: Record<string, any>;
  annualRequirements: string[];
  processingTime: string;
  privacyLevel: string;
  type?: string;
  name?: string;
  nameReservationFee?:number;
  nameAvailabilitySearchFee?:number;
};

export const stateOptions:Record<string, StateOption> = {
  FL: {
    "id": "q3-fl",
    "label": "Florida",
    "value": "FL",
    "field": "state",
    "LLC": 9,
    "Corporation": 8,
    "Nonprofit": 7,
    
    "formationFee": {
      LLC:100,
      Corporation:90,
      Nonprofit:90,
      nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25},},
    "annualRequirements": [
      "Annual Report"
    ],
    "processingTime": "7-8 business days",
    "privacyLevel": "Modarate",
    "type": "stateOption",
    "name": "Florida"
  },
  DE: {
    "id": "q3-de",
    "label": "Delaware",
    "value": "DE",
    "field": "state",
    "LLC": 6,
    "Corporation": 10,
    "Nonprofit": 4,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements": [
      "Annual Report"
    ],
    "processingTime": "5-10 days",
    "privacyLevel": "Modarate",
    "type": "stateOption",
    "name": "Delaware"
  },
  WY: {
    "id": "q3-wy",
    "label": "Wyoming",
    "value": "WY",
    "field": "state",
    "LLC": 10,
    "Corporation": 7,
    "Nonprofit": 5,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements": [
      "Annual Report"
    ],
    "processingTime": "5-10 days",
    "privacyLevel": "Modarate",
    "type": "stateOption",
    "name": "Wyoming"
  },
  AL:{
    "id": "q3-al",
    "label": "Alabama",
    "value": "AL",
    "field": "state",
    "LLC": 7,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  AK:{
    "id": "q3-ak",
    "label": "Alaska",
    "value": "AK",
    "field": "state",
    "LLC": 7,
    "Corporation": 5,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  AZ:{
    "id": "q3-az",
    "label": "Arizona",
    "value": "AZ",
    "field": "state",
    "LLC": 8,
    "Corporation": 7,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  AR:{
    "id": "q3-ar",
    "label": "Arkansas",
    "value": "AR",
    "field": "state",
    "LLC": 6,
    "Corporation": 5,
    "Nonprofit": 5,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  CA:{
    "id": "q3-ca",
    "label": "California",
    "value": "CA",
    "field": "state",
    "LLC": 4,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  CO:{
    "id": "q3-co",
    "label": "Colorado",
    "value": "CO",
    "field": "state",
    "LLC": 7,
    "Corporation": 7,
    "Nonprofit": 7,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  CT:{
    "id": "q3-ct",
    "label": "Connecticut",
    "value": "CT",
    "field": "state",
    "LLC": 5,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  GA:{
    "id": "q3-ga",
    "label": "Georgia",
    "value": "GA",
    "field": "state",
    "LLC": 8,
    "Corporation": 7,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  HI:{
    "id": "q3-hi",
    "label": "Hawaii",
    "value": "HI",
    "field": "state",
    "LLC": 5,
    "Corporation": 5,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  ID:{
    "id": "q3-id",
    "label": "Idaho",
    "value": "ID",
    "field": "state",
    "LLC": 8,
    "Corporation": 6,
    "Nonprofit": 5,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  IL:{
    "id": "q3-il",
    "label": "Illinois",
    "value": "IL",
    "field": "state",
    "LLC": 6,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"65-10 days",
    "privacyLevel":"Modarate"
  },
  IN:{
    "id": "q3-in",
    "label": "Indiana",
    "value": "IN",
    "field": "state",
    "LLC": 7,
    "Corporation": 6,
    "Nonprofit": 5,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  IA:{
    "id": "q3-ia",
    "label": "Iowa",
    "value": "IA",
    "field": "state",
    "LLC": 6,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  KS:{
    "id": "q3-ks",
    "label": "Kansas",
    "value": "KS",
    "field": "state",
    "LLC": 6,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  KY:{
    "id": "q3-ky",
    "label": "Kentucky",
    "value": "KY",
    "field": "state",
    "LLC": 6,
    "Corporation": 5,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  LA:{
    "id": "q3-la",
    "label": "Louisiana",
    "value": "LA",
    "field": "state",
    "LLC": 6,
    "Corporation": 5,
    "Nonprofit": 5,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  ME:{
    "id": "q3-me",
    "label": "Maine",
    "value": "ME",
    "field": "state",
    "LLC": 7,
    "Corporation": 6,
    "Nonprofit": 7,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  MD:{
    "id": "q3-md",
    "label": "Maryland",
    "value": "MD",
    "field": "state",
    "LLC": 6,
    "Corporation": 6,
    "Nonprofit": 7,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  MA:{
    "id": "q3-ma",
    "label": "Massachusetts",
    "value": "MA",
    "field": "state",
    "LLC": 5,
    "Corporation": 7,
    "Nonprofit": 7,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  MI:{
    "id": "q3-mi",
    "label": "Michigan",
    "value": "MI",
    "field": "state",
    "LLC": 6,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  MN:{
    "id": "q3-mn",
    "label": "Minnesota",
    "value": "MN",
    "field": "state",
    "LLC": 7,
    "Corporation": 6,
    "Nonprofit": 7,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  MS:{
    "id": "q3-ms",
    "label": "Mississippi",
    "value": "MS",
    "field": "state",
    "LLC": 6,
    "Corporation": 5,
    "Nonprofit": 5,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  MO:{
    "id": "q3-mo",
    "label": "Missouri",
    "value": "MO",
    "field": "state",
    "LLC": 7,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  MT:{
    "id": "q3-mt",
    "label": "Montana",
    "value": "MT",
    "field": "state",
    "LLC": 8,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  NE:{
    "id": "q3-ne",
    "label": "Nebraska",
    "value": "NE",
    "field": "state",
    "LLC": 6,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  NV:{
    "id": "q3-nv",
    "label": "Nevada",
    "value": "NV",
    "field": "state",
    "LLC": 9,
    "Corporation": 8,
    "Nonprofit": 5,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  NH:{
    "id": "q3-nh",
    "label": "New Hampshire",
    "value": "NH",
    "field": "state",
    "LLC": 7,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  NJ:{
    "id": "q3-nj",
    "label": "New Jersey",
    "value": "NJ",
    "field": "state",
    "LLC": 5,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  NM:{
    "id": "q3-nm",
    "label": "New Mexico",
    "value": "NM",
    "field": "state",
    "LLC": 6,
    "Corporation": 5,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  NY:{
    "id": "q3-ny",
    "label": "New York",
    "value": "NY",
    "field": "state",
    "LLC": 5,
    "Corporation": 6,
    "Nonprofit": 7,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  NC:{
    "id": "q3-nc",
    "label": "North Carolina",
    "value": "NC",
    "field": "state",
    "LLC": 7,
    "Corporation": 7,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  ND:{
    "id": "q3-nd",
    "label": "North Dakota",
    "value": "ND",
    "field": "state",
    "LLC": 6,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  OH:{
    "id": "q3-oh",
    "label": "Ohio",
    "value": "OH",
    "field": "state",
    "LLC": 7,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  OK:{
    "id": "q3-ok",
    "label": "Oklahoma",
    "value": "OK",
    "field": "state",
    "LLC": 7,
    "Corporation": 6,
    "Nonprofit": 5,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  OR:{
    "id": "q3-or",
    "label": "Oregon",
    "value": "OR",
    "field": "state",
    "LLC": 6,
    "Corporation": 6,
    "Nonprofit": 7,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  PA:{
    "id": "q3-pa",
    "label": "Pennsylvania",
    "value": "PA",
    "field": "state",
    "LLC": 6,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  RI:{
    "id": "q3-ri",
    "label": "Rhode Island",
    "value": "RI",
    "field": "state",
    "LLC": 5,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  SC:{
    "id": "q3-sc",
    "label": "South Carolina",
    "value": "SC",
    "field": "state",
    "LLC": 7,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  SD:{
    "id": "q3-sd",
    "label": "South Dakota",
    "value": "SD",
    "field": "state",
    "LLC": 8,
    "Corporation": 6,
    "Nonprofit": 5,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  TN:{
    "id": "q3-tn",
    "label": "Tennessee",
    "value": "TN",
    "field": "state",
    "LLC": 8,
    "Corporation": 7,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  TX:{
    "id": "q3-tx",
    "label": "Texas",
    "value": "TX",
    "field": "state",
    "LLC": 9,
    "Corporation": 7,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  UT:{
    "id": "q3-ut",
    "label": "Utah",
    "value": "UT",
    "field": "state",
    "LLC": 8,
    "Corporation": 6,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  VT:{
    "id": "q3-vt",
    "label": "Vermont",
    "value": "VT",
    "field": "state",
    "LLC": 6,
    "Corporation": 6,
    "Nonprofit": 7,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  VA:{
    "id": "q3-va",
    "label": "Virginia",
    "value": "VA",
    "field": "state",
    "LLC": 7,
    "Corporation": 7,
    "Nonprofit": 7,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  WA:{
    "id": "q3-wa",
    "label": "Washington",
    "value": "WA",
    "field": "state",
    "LLC": 6,
    "Corporation": 7,
    "Nonprofit": 7,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  WV:{
    "id": "q3-wv",
    "label": "West Virginia",
    "value": "WV",
    "field": "state",
    "LLC": 6,
    "Corporation": 5,
    "Nonprofit": 6,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  WI:{
    "id": "q3-wi",
    "label": "Wisconsin",
    "value": "WI",
    "field": "state",
    "LLC": 7,
    "Corporation": 6,
    "Nonprofit": 7,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  },
  DC:{
    "id": "q3-dc",
    "label": "District of Columbia",
    "value": "DC",
    "field": "state",
    "LLC": 5,
    "Corporation": 6,
    "Nonprofit": 7,
    "formationFee":{LLC:90,Corporation:90,Nonprofit:90,nameReservationFee:{LLC:25,Corporation:25,Nonprofit:25}},
    "annualRequirements":["Annual Report"],
    "processingTime":"5-10 days",
    "privacyLevel":"Modarate"
  }
} as const;


export interface EntityTypeInfo {
  id: string;
  value: string;
  state: string;
  recommendationScore?: number;
  [key: string]: boolean | string | any[] | undefined | {};

}
export interface EntityInfo {
  id: string;
  value: string;
  label: string;
  field: string;
  name: string;
  privacyLevel: number;
  annualRequirements: string;
  LLC: EntityTypeInfo|any;
  Corporation: EntityTypeInfo|any;
  "C Corporation"?: EntityTypeInfo|any;
  Nonprofit: EntityTypeInfo|any;
}

export const statesFeatured:Record<string,EntityInfo>={
  "FL": {
    "id": "FL",
    "value": "FL",
    "label": "Florida",
    "field": "state",
    "privacyLevel": 3,
    "name": "Florida",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "FL",
      "value": "FL",
      "state": "Florida",
      "standartProcessing": "7–8 business days",
      "filingFee": 100,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 125,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 138.75,
      "lateFilingPenalties": 400,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 25,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 25,
      "certifiedCopyOfDocuments": 30,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 30,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 400,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 9,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "FL",
      "value": "FL",
      "state": "Florida",
      "standartProcessing": "7–8 business days",
      "filingFee": 70,
      "nameReservationFee": 35,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Available",
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 87.5,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 150,
      "lateFilingPenalties": 400,
      "amendmentToArticlesOfOrganization": 35,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 25,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 35,
      "mergerAndConversionFilings": 25,
      "certifiedCopyOfDocuments": 30,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 30,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "{\n  \"rate\": 0.055,\n  \"appliesTo\": \"net income\",\n  \"threshold\": 50000,\n  \"thresholdType\": \"over\",\n  \"description\": \"5.5% on net income over $50,000\",\n  \"explanation\": \"A tax rate of 5.5% is applied only to the portion of net income that exceeds $50,000.\"\n}\n",
      "annualFranchiseOrPrivilegeTaxes ": 400,
      "lateOrMissedPaymentPenalties": "Varies",
      "recommendationScore": 8,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "C Corporation": {
      "id": "FL",
      "value": "FL",
      "state": "Florida",
      "standartProcessing": "7–8 business days",
      "filingFee": 70,
      "nameReservationFee": 35,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Available",
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 87.5,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 150,
      "lateFilingPenalties": 400,
      "amendmentToArticlesOfOrganization": 35,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 25,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 35,
      "mergerAndConversionFilings": 25,
      "certifiedCopyOfDocuments": 30,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 30,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "{\n  \"rate\": 0.055,\n  \"appliesTo\": \"net income\",\n  \"threshold\": 50000,\n  \"thresholdType\": \"over\",\n  \"description\": \"5.5% on net income over $50,000\",\n  \"explanation\": \"A tax rate of 5.5% is applied only to the portion of net income that exceeds $50,000.\"\n}\n",
      "annualFranchiseOrPrivilegeTaxes ": 400,
      "lateOrMissedPaymentPenalties": "Varies",
      "recommendationScore": 8,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "FL",
      "value": "FL",
      "state": "Florida",
      "standartProcessing": "10–15 business days",
      "filingFee": 35,
      "nameReservationFee": 35,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 25,
      "certificateOfStatus": 8.75,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 87.5,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 61.25,
      "lateFilingPenalties": "None",
      "amendmentToArticlesOfOrganization": 35,
      "reinstatement": 175,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 35,
      "mergerAndConversionFilings": 87.5,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 10,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 61.25,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "DE": {
    "id": "DE",
    "value": "DE",
    "label": "Delaware",
    "field": "state",
    "privacyLevel": 4,
    "name": "Delaware",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "DE",
      "value": "DE",
      "state": "Delaware",
      "standartProcessing": "8–10 business days",
      "filingFee": 90,
      "nameReservationFee": 75,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": 50,
      "certificateOfStatus": 50,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 200,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": "None",
      "lateFilingPenalties": 200,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 200,
      "registeredAgentChange": 50,
      "businessAddressUpdate": 50,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 200,
      "mergerAndConversionFilings": 200,
      "certifiedCopyOfDocuments": 50,
      "copiesOfFiledDocuments": 2,
      "franchiseTaxFees": 300,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 20,
      "apostilleAndAuthenticationServices": 300,
      "annualFranchiseOrPrivilegeTaxes ": 200,
      "lateOrMissedPaymentPenalties": "[50–450]",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 4
    },
    "Corporation": {
      "id": "DE",
      "value": "DE",
      "state": "Delaware",
      "standartProcessing": "8–10 business days",
      "filingFee": 89,
      "nameReservationFee": 75,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Available",
      "certificateOfStatus": 50,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 245,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 50,
      "lateFilingPenalties": 125,
      "amendmentToArticlesOfOrganization": 200,
      "reinstatement": 200,
      "registeredAgentChange": 50,
      "businessAddressUpdate": 50,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 200,
      "mergerAndConversionFilings": 200,
      "certifiedCopyOfDocuments": 50,
      "copiesOfFiledDocuments": 2,
      "franchiseTaxFees": "Varies",
      "publicationRequirements": "Required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 20,
      "apostilleAndAuthenticationServices": "Varies",
      "annualFranchiseOrPrivilegeTaxes ": 200,
      "lateOrMissedPaymentPenalties": "[50–450]",
      "recommendationScore": 10,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 4
    },
    "Nonprofit": {
      "id": "DE",
      "value": "DE",
      "state": "Delaware",
      "standartProcessing": "10–15 business days",
      "filingFee": 89,
      "nameReservationFee": 75,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "{\"1h\":1,000,\"2h\":500}",
      "certificateOfStatus": 50,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 125,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 25,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 4,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "WY": {
    "id": "WY",
    "value": "WY",
    "label": "Wyoming",
    "field": "state",
    "privacyLevel": 5,
    "name": "Wyoming",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "WY",
      "value": "WY",
      "state": "Wyoming",
      "standartProcessing": "10–12 business days",
      "filingFee": 100,
      "nameReservationFee": 50,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 20,
      "fictitiousNameDBARegistration": 100,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": "{\n  \"baseFee\": 60,\n  \"perAssetFee\": 0.0002,\n  \"perAssetUnit\": 1,\n  \"description\": \"$60 or $0.0002 per $1 of assets (whichever is greater)\",\n  \"unitExplanation\": \"You pay $60 minimum, or $0.0002 for each $1 of assets if that amount is higher.\"\n}\n",
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 60,
      "reinstatement": 100,
      "registeredAgentChange": 5,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 60,
      "articlesOfDissolution": 60,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 20,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 60,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 10,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 5
    },
    "Corporation": {
      "id": "WY",
      "value": "WY",
      "state": "Wyoming",
      "standartProcessing": "10–12 business days",
      "filingFee": 100,
      "nameReservationFee": 50,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 20,
      "fictitiousNameDBARegistration": 100,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": "{\n  \"baseFee\": 60,\n  \"perAssetFee\": 0.0002,\n  \"perAssetUnit\": 1,\n  \"description\": \"$60 or $0.0002 per $1 of assets (whichever is greater)\",\n  \"unitExplanation\": \"You pay $60 minimum, or $0.0002 for each $1 of assets if that amount is higher.\"\n}\n",
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 60,
      "reinstatement": 100,
      "registeredAgentChange": 5,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 60,
      "articlesOfDissolution": 60,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 20,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 60,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 5
    },
    "Nonprofit": {
      "id": "WY",
      "value": "WY",
      "state": "Wyoming",
      "standartProcessing": "10–12 business days",
      "filingFee": 50,
      "nameReservationFee": 60,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "{\"1h\":500,\"2h\":100,\"24h\":60}",
      "certificateOfStatus": 0,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 60,
      "trademarkAndServiceMarkRegistration": 60,
      "annualReportFee": 0,
      "lateFilingPenalties": 60,
      "amendmentToArticlesOfOrganization": 60,
      "reinstatement": 60,
      "registeredAgentChange": 60,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 60,
      "articlesOfDissolution": 60,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 60,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 60,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "AL": {
    "id": "AL",
    "value": "AL",
    "label": "Alabama",
    "field": "state",
    "privacyLevel": 3,
    "name": "Alabama",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "AL",
      "value": "AL",
      "state": "Alabama",
      "standartProcessing": "8–10 business days",
      "filingFee": 200,
      "nameReservationFee": 28,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": 100,
      "certificateOfStatus": 25,
      "fictitiousNameDBARegistration": 30,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 10,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 100,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 50,
      "changeOfManagementOfficerFilingFees": 100,
      "articlesOfDissolution": 100,
      "mergerAndConversionFilings": 10,
      "certifiedCopyOfDocuments": 5,
      "copiesOfFiledDocuments": "{\n  \"minimumFee\": 100,\n  \"description\": \"Minimum $100\",\n  \"explanation\": \"The minimum fee to be paid is $100 regardless of other calculations.\"\n}\n",
      "franchiseTaxFees": "Not required",
      "publicationRequirements": 50,
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 5,
      "apostilleAndAuthenticationServices": "{\n  \"minimumFee\": 100,\n  \"description\": \"Minimum $100\",\n  \"explanation\": \"The minimum fee to be paid is $100 regardless of other calculations.\"\n}\n",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "AL",
      "value": "AL",
      "state": "Alabama",
      "standartProcessing": "8–10 business days",
      "filingFee": 200,
      "nameReservationFee": 28,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 30,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 100,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 25,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": 5,
      "franchiseTaxFees": "Varies",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Varies",
      "UCCFilings": 20,
      "apostilleAndAuthenticationServices": 25,
      "annualFranchiseOrPrivilegeTaxes ": "Varies",
      "lateOrMissedPaymentPenalties": 50,
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "AL",
      "value": "AL",
      "state": "Alabama",
      "standartProcessing": "5–10 business days",
      "filingFee": 200,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": "None",
      "lateFilingPenalties": "None",
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "AK": {
    "id": "AK",
    "value": "AK",
    "label": "Alaska",
    "field": "state",
    "privacyLevel": 3,
    "name": "Alaska",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "AK",
      "value": "AK",
      "state": "Alaska",
      "standartProcessing": "15–20 business days",
      "filingFee": 250,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 350,
      "trademarkAndServiceMarkRegistration": "Not specified",
      "annualReportFee": 100,
      "lateFilingPenalties": 38,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": "Not specified",
      "registeredAgentChange": 25,
      "businessAddressUpdate": "No charge",
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 25,
      "certifiedCopyOfDocuments": 5,
      "copiesOfFiledDocuments": 10,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 40,
      "apostilleAndAuthenticationServices": 25,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 38,
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "AK",
      "value": "AK",
      "state": "Alaska",
      "standartProcessing": "15–20 business days",
      "filingFee": 250,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 350,
      "trademarkAndServiceMarkRegistration": "Not specified",
      "annualReportFee": 100,
      "lateFilingPenalties": 38,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": "Varies",
      "registeredAgentChange": 25,
      "businessAddressUpdate": "No charge",
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 25,
      "certifiedCopyOfDocuments": 5,
      "copiesOfFiledDocuments": 10,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 40,
      "apostilleAndAuthenticationServices": 25,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 50,
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "AK",
      "value": "AK",
      "state": "Alaska",
      "standartProcessing": "10–15 business days",
      "filingFee": 50,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 25,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "AZ": {
    "id": "AZ",
    "value": "AZ",
    "label": "Arizona",
    "field": "state",
    "privacyLevel": 3,
    "name": "Arizona",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "AZ",
      "value": "AZ",
      "state": "Arizona",
      "standartProcessing": "15–21 business days",
      "filingFee": 50,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": 35,
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 15,
      "annualReportFee": "None",
      "lateFilingPenalties": "None",
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 100,
      "registeredAgentChange": 5,
      "businessAddressUpdate": 5,
      "changeOfManagementOfficerFilingFees": 5,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 15,
      "copiesOfFiledDocuments": 5,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Required in certain counties",
      "expeditedDocumentRetrieval": 35,
      "UCCFilings": 40,
      "apostilleAndAuthenticationServices": 25,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 8,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "AZ",
      "value": "AZ",
      "state": "Arizona",
      "standartProcessing": "15–21 business days",
      "filingFee": 60,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 175,
      "trademarkAndServiceMarkRegistration": 15,
      "annualReportFee": 45,
      "lateFilingPenalties": 9,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 100,
      "registeredAgentChange": 5,
      "businessAddressUpdate": 5,
      "changeOfManagementOfficerFilingFees": 5,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 5,
      "copiesOfFiledDocuments": 5,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Required",
      "expeditedDocumentRetrieval": 35,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": 3,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 50,
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "AZ",
      "value": "AZ",
      "state": "Arizona",
      "standartProcessing": "10–15 business days",
      "filingFee": 40,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 35,
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 10,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "AR": {
    "id": "AR",
    "value": "AR",
    "label": "Arkansas",
    "field": "state",
    "privacyLevel": 3,
    "name": "Arkansas",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "AR",
      "value": "AR",
      "state": "Arkansas",
      "standartProcessing": "8–12 business days",
      "filingFee": 45,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 15,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 270,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 150,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 45,
      "reinstatement": 25,
      "registeredAgentChange": 0,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 0,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 5,
      "copiesOfFiledDocuments": 0,
      "franchiseTaxFees": 150,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 15,
      "apostilleAndAuthenticationServices": 10,
      "annualFranchiseOrPrivilegeTaxes ": 150,
      "lateOrMissedPaymentPenalties": 25,
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "AR",
      "value": "AR",
      "state": "Arkansas",
      "standartProcessing": "8–12 business days",
      "filingFee": 50,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Available",
      "certificateOfStatus": 15,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 300,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 150,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 25,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 5,
      "copiesOfFiledDocuments": 5,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 15,
      "apostilleAndAuthenticationServices": 10,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 50,
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "AR",
      "value": "AR",
      "state": "Arkansas",
      "standartProcessing": "10–15 business days",
      "filingFee": 50,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": "None",
      "lateFilingPenalties": "None",
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "CA": {
    "id": "CA",
    "value": "CA",
    "label": "California",
    "field": "state",
    "privacyLevel": 2,
    "name": "California",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "CA",
      "value": "CA",
      "state": "California",
      "standartProcessing": "10–15 business days",
      "filingFee": 70,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": 4,
      "rushFilings": "[350,750]",
      "certificateOfStatus": 6,
      "fictitiousNameDBARegistration": 26,
      "foreignQualification ": 70,
      "trademarkAndServiceMarkRegistration": 70,
      "annualReportFee": 20,
      "lateFilingPenalties": "{\n  \"rate\": 0.05,\n  \"rateUnit\": \"per month\",\n  \"maximumRate\": 0.25,\n  \"description\": \"5% per month up to 25%\",\n  \"explanation\": \"A penalty of 5% is applied for each month of delay, but the total penalty will not exceed 25%.\"\n}\n",
      "amendmentToArticlesOfOrganization": 30,
      "reinstatement": 20,
      "registeredAgentChange": 20,
      "businessAddressUpdate": 20,
      "changeOfManagementOfficerFilingFees": 20,
      "articlesOfDissolution": 30,
      "mergerAndConversionFilings": 30,
      "certifiedCopyOfDocuments": 5,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": 800,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "[350–750]",
      "UCCFilings": 40,
      "apostilleAndAuthenticationServices": 20,
      "annualFranchiseOrPrivilegeTaxes ": 800,
      "lateOrMissedPaymentPenalties": "{\n  \"penaltyRate\": 0.05,\n  \"rateUnit\": \"month\",\n  \"maximumPenaltyRate\": 0.25,\n  \"description\": \"5% per month, up to a maximum of 25%\",\n  \"explanation\": \"A penalty of 5% is applied for each month of delay, but the total penalty cannot exceed 25% of the original amount.\"\n}\n",
      "recommendationScore": 4,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 2
    },
    "Corporation": {
      "id": "CA",
      "value": "CA",
      "state": "California",
      "standartProcessing": "10–15 business days",
      "filingFee": 125,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Available",
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 26,
      "foreignQualification ": 70,
      "trademarkAndServiceMarkRegistration": 70,
      "annualReportFee": 25,
      "lateFilingPenalties": 250,
      "amendmentToArticlesOfOrganization": 30,
      "reinstatement": 30,
      "registeredAgentChange": 20,
      "businessAddressUpdate": 20,
      "changeOfManagementOfficerFilingFees": 20,
      "articlesOfDissolution": 30,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 5,
      "copiesOfFiledDocuments": 5,
      "franchiseTaxFees": 800,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 350,
      "UCCFilings": 20,
      "apostilleAndAuthenticationServices": 20,
      "annualFranchiseOrPrivilegeTaxes ": 800,
      "lateOrMissedPaymentPenalties": 250,
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 2
    },
    "Nonprofit": {
      "id": "CA",
      "value": "CA",
      "state": "California",
      "standartProcessing": "10–15 business days",
      "filingFee": 30,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 350,
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 20,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "CO": {
    "id": "CO",
    "value": "CO",
    "label": "Colorado",
    "field": "state",
    "privacyLevel": 3,
    "name": "Colorado",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "CO",
      "value": "CO",
      "state": "Colorado",
      "standartProcessing": "5 business days",
      "filingFee": 50,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 20,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 25,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 100,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 10,
      "changeOfManagementOfficerFilingFees": 10,
      "articlesOfDissolution": 10,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": 5,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 40,
      "apostilleAndAuthenticationServices": 25,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 50,
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "CO",
      "value": "CO",
      "state": "Colorado",
      "standartProcessing": "5 business days",
      "filingFee": 50,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 20,
      "foreignQualification ": 125,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 10,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 50,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 10,
      "changeOfManagementOfficerFilingFees": 10,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 75,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": 5,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 20,
      "apostilleAndAuthenticationServices": 25,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 50,
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "CO",
      "value": "CO",
      "state": "Colorado",
      "standartProcessing": "1–3 business days",
      "filingFee": 50,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "{\"1h\":150,\"2h\":100,\"24h\":50}",
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 20,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 25,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 100,
      "reinstatement": 10,
      "registeredAgentChange": 0,
      "businessAddressUpdate": 25,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 100,
      "mergerAndConversionFilings": 10,
      "certifiedCopyOfDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "copiesOfFiledDocuments": 10,
      "franchiseTaxFees": "Not required",
      "publicationRequirements": 25,
      "expeditedDocumentRetrieval": 10,
      "UCCFilings": "None",
      "apostilleAndAuthenticationServices": 50,
      "annualFranchiseOrPrivilegeTaxes ": "Varies by municipality",
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "CT": {
    "id": "CT",
    "value": "CT",
    "label": "Connecticut",
    "field": "state",
    "privacyLevel": 3,
    "name": "Connecticut",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "CT",
      "value": "CT",
      "state": "Connecticut",
      "standartProcessing": "12–15 business days",
      "filingFee": 120,
      "nameReservationFee": 60,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": 50,
      "certificateOfStatus": 50,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 120,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 80,
      "lateFilingPenalties": 100,
      "amendmentToArticlesOfOrganization": 120,
      "reinstatement": 100,
      "registeredAgentChange": 20,
      "businessAddressUpdate": 20,
      "changeOfManagementOfficerFilingFees": 20,
      "articlesOfDissolution": 100,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 40,
      "copiesOfFiledDocuments": 5,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 80,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "CT",
      "value": "CT",
      "state": "Connecticut",
      "standartProcessing": "12–15 business days",
      "filingFee": 250,
      "nameReservationFee": 60,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Available",
      "certificateOfStatus": 50,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 250,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 150,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 100,
      "reinstatement": 100,
      "registeredAgentChange": 20,
      "businessAddressUpdate": 20,
      "changeOfManagementOfficerFilingFees": 20,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 40,
      "copiesOfFiledDocuments": 5,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": 100,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 100,
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "CT",
      "value": "CT",
      "state": "Connecticut",
      "standartProcessing": "10–15 business days",
      "filingFee": 50,
      "nameReservationFee": 60,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 80,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 120,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 50,
      "lateFilingPenalties": 120,
      "amendmentToArticlesOfOrganization": 110,
      "reinstatement": 50,
      "registeredAgentChange": 50,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 80,
      "certifiedCopyOfDocuments": 40,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 50,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "GA": {
    "id": "GA",
    "value": "GA",
    "label": "Georgia",
    "field": "state",
    "privacyLevel": 3,
    "name": "Georgia",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "GA",
      "value": "GA",
      "state": "Georgia",
      "standartProcessing": "20 business days",
      "filingFee": 100,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": 100,
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 225,
      "trademarkAndServiceMarkRegistration": 15,
      "annualReportFee": 50,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 20,
      "reinstatement": 250,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 10,
      "changeOfManagementOfficerFilingFees": 10,
      "articlesOfDissolution": 0,
      "mergerAndConversionFilings": 25,
      "certifiedCopyOfDocuments": 20,
      "copiesOfFiledDocuments": 10,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 8,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "GA",
      "value": "GA",
      "state": "Georgia",
      "standartProcessing": "20 business days",
      "filingFee": 100,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 225,
      "trademarkAndServiceMarkRegistration": 15,
      "annualReportFee": 50,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 20,
      "reinstatement": 250,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 10,
      "changeOfManagementOfficerFilingFees": 10,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 20,
      "copiesOfFiledDocuments": 10,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "Varies",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "GA",
      "value": "GA",
      "state": "Georgia",
      "standartProcessing": "10–15 business days",
      "filingFee": 30,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "{\"1h\":100,\"2h\":250}",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 225,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 30,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 10,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 30,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "HI": {
    "id": "HI",
    "value": "HI",
    "label": "Hawaii",
    "field": "state",
    "privacyLevel": 3,
    "name": "Hawaii",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "HI",
      "value": "HI",
      "state": "Hawaii",
      "standartProcessing": "8–10 business days",
      "filingFee": 50,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": 25,
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 50,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 15,
      "lateFilingPenalties": 10,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 25,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 25,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 0.25,\n  \"unit\": \"page\",\n  \"description\": \"$0.25 per page\",\n  \"explanation\": \"A fee of $0.25 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 10,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "HI",
      "value": "HI",
      "state": "Hawaii",
      "standartProcessing": "8–10 business days",
      "filingFee": 50,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Available",
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 50,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 15,
      "lateFilingPenalties": 10,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 25,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 25,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 0.25,\n  \"unit\": \"page\",\n  \"description\": \"$0.25 per page\",\n  \"explanation\": \"A fee of $0.25 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 10,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "HI",
      "value": "HI",
      "state": "Hawaii",
      "standartProcessing": "5–10 business days",
      "filingFee": 25,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 25,
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 25,
      "trademarkAndServiceMarkRegistration": 10,
      "annualReportFee": 5,
      "lateFilingPenalties": 10,
      "amendmentToArticlesOfOrganization": 10,
      "reinstatement": 10,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 10,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 10,
      "certifiedCopyOfDocuments": "{\n  \"unitFee\": 0.25,\n  \"unit\": \"page\",\n  \"description\": \"$0.25 per page\",\n  \"explanation\": \"A fee of $0.25 is charged for each page.\"\n}\n",
      "copiesOfFiledDocuments": 10,
      "franchiseTaxFees": "Not required",
      "publicationRequirements": 10,
      "expeditedDocumentRetrieval": 10,
      "UCCFilings": "None",
      "apostilleAndAuthenticationServices": 5,
      "annualFranchiseOrPrivilegeTaxes ": "Varies by municipality",
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "ID": {
    "id": "ID",
    "value": "ID ",
    "label": "Idaho",
    "field": "state",
    "privacyLevel": 3,
    "name": "Idaho",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "ID ",
      "value": "ID ",
      "state": "Idaho",
      "standartProcessing": "12–15 business days",
      "filingFee": 100,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 0,
      "lateFilingPenalties": 0,
      "amendmentToArticlesOfOrganization": 30,
      "reinstatement": 30,
      "registeredAgentChange": 0,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 0,
      "articlesOfDissolution": 30,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 20,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 0,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 8,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "ID ",
      "value": "ID ",
      "state": "Idaho",
      "standartProcessing": "12–15 business days",
      "filingFee": 100,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 0,
      "lateFilingPenalties": 0,
      "amendmentToArticlesOfOrganization": 30,
      "reinstatement": 30,
      "registeredAgentChange": 0,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 0,
      "articlesOfDissolution": 30,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 20,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 0,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "ID ",
      "value": "ID ",
      "state": "Idaho",
      "standartProcessing": "10–15 business days",
      "filingFee": "30-50",
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 30,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 0,
      "lateFilingPenalties": "None",
      "amendmentToArticlesOfOrganization": 30,
      "reinstatement": 30,
      "registeredAgentChange": 20,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 30,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 30,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 30,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 30,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 0,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "IL": {
    "id": "IL",
    "value": "IL",
    "label": "Illinois",
    "field": "state",
    "privacyLevel": 3,
    "name": "Illinois",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "IL",
      "value": "IL",
      "state": "Illinois",
      "standartProcessing": "19–25 business days",
      "filingFee": 150,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": 100,
      "certificateOfStatus": 25,
      "fictitiousNameDBARegistration": 150,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 10,
      "annualReportFee": 75,
      "lateFilingPenalties": 100,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 200,
      "registeredAgentChange": 25,
      "businessAddressUpdate": "No charge",
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 5,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 25,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 40,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 100,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "IL",
      "value": "IL",
      "state": "Illinois",
      "standartProcessing": "19–25 business days",
      "filingFee": 150,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Available",
      "certificateOfStatus": 25,
      "fictitiousNameDBARegistration": 30,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 10,
      "annualReportFee": 75,
      "lateFilingPenalties": 100,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 200,
      "registeredAgentChange": 25,
      "businessAddressUpdate": "No charge",
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 60,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 25,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 40,
      "apostilleAndAuthenticationServices": "Varies",
      "annualFranchiseOrPrivilegeTaxes ": 100,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "IL",
      "value": "IL",
      "state": "Illinois",
      "standartProcessing": "10–15 business days",
      "filingFee": 10,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 50,
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 50,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 10,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 15,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 10,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "IN": {
    "id": "IN",
    "value": "IN",
    "label": "Indiana",
    "field": "state",
    "privacyLevel": 3,
    "name": "Indiana",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "IN",
      "value": "IN",
      "state": "Indiana",
      "standartProcessing": "7 business days",
      "filingFee": 95,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 15,
      "fictitiousNameDBARegistration": 20,
      "foreignQualification ": 125,
      "trademarkAndServiceMarkRegistration": 10,
      "annualReportFee": 32,
      "lateFilingPenalties": 30,
      "amendmentToArticlesOfOrganization": 20,
      "reinstatement": 30,
      "registeredAgentChange": 20,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 20,
      "articlesOfDissolution": 20,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 25,
      "apostilleAndAuthenticationServices": 10,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 30,
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "IN",
      "value": "IN",
      "state": "Indiana",
      "standartProcessing": "7 business days",
      "filingFee": 95,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 15,
      "fictitiousNameDBARegistration": 20,
      "foreignQualification ": 125,
      "trademarkAndServiceMarkRegistration": 10,
      "annualReportFee": 32,
      "lateFilingPenalties": 30,
      "amendmentToArticlesOfOrganization": 20,
      "reinstatement": 30,
      "registeredAgentChange": 20,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 20,
      "articlesOfDissolution": 20,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 25,
      "apostilleAndAuthenticationServices": 10,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 30,
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "IN",
      "value": "IN",
      "state": "Indiana",
      "standartProcessing": "10–15 business days",
      "filingFee": 30,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 50,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 10,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 10,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "IA": {
    "id": "IA",
    "value": "IA",
    "label": "Iowa",
    "field": "state",
    "privacyLevel": 3,
    "name": "Iowa",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "IA",
      "value": "IA",
      "state": "Iowa",
      "standartProcessing": "8–12 business days",
      "filingFee": 50,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "{\"5-day\":15, \"2-day\":50}",
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 5,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 10,
      "annualReportFee": 60,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 10,
      "reinstatement": 50,
      "registeredAgentChange": 0,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 0,
      "articlesOfDissolution": 10,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 0.50,\n  \"unit\": \"page\",\n  \"description\": \"$0.50 per page\",\n  \"explanation\": \"A fee of $0.50 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 60,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "IA",
      "value": "IA",
      "state": "Iowa",
      "standartProcessing": "8–12 business days",
      "filingFee": 50,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Available",
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 5,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 10,
      "annualReportFee": 60,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 10,
      "reinstatement": 50,
      "registeredAgentChange": 0,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 0,
      "articlesOfDissolution": 10,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 0.50,\n  \"unit\": \"page\",\n  \"description\": \"$0.50 per page\",\n  \"explanation\": \"A fee of $0.50 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 60,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "IA",
      "value": "IA",
      "state": "Iowa",
      "standartProcessing": "10–15 business days",
      "filingFee": 20,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 25,
      "trademarkAndServiceMarkRegistration": 25,
      "annualReportFee": 10,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 50,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 10,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 10,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "KS": {
    "id": "KS",
    "value": "KS",
    "label": "Kansas",
    "field": "state",
    "privacyLevel": 3,
    "name": "Kansas",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "KS",
      "value": "KS",
      "state": "Kansas",
      "standartProcessing": "8–10 business days",
      "filingFee": 165,
      "nameReservationFee": 30,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 35,
      "foreignQualification ": 165,
      "trademarkAndServiceMarkRegistration": 40,
      "annualReportFee": 50,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 35,
      "reinstatement": 50,
      "registeredAgentChange": 0,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 0,
      "articlesOfDissolution": 35,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 20,
      "apostilleAndAuthenticationServices": 10,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 50,
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "KS",
      "value": "KS",
      "state": "Kansas",
      "standartProcessing": "8–10 business days",
      "filingFee": 85,
      "nameReservationFee": 30,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 35,
      "foreignQualification ": 165,
      "trademarkAndServiceMarkRegistration": 40,
      "annualReportFee": 50,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 35,
      "reinstatement": 50,
      "registeredAgentChange": 0,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 0,
      "articlesOfDissolution": 35,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 20,
      "apostilleAndAuthenticationServices": 10,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 50,
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "KS",
      "value": "KS",
      "state": "Kansas",
      "standartProcessing": "5–10 business days",
      "filingFee": 20,
      "nameReservationFee": 30,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 20,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 80,
      "lateFilingPenalties": "None",
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "KY": {
    "id": "KY",
    "value": "KY",
    "label": "Kentucky",
    "field": "state",
    "privacyLevel": 3,
    "name": "Kentucky",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "KY",
      "value": "KY",
      "state": "Kentucky",
      "standartProcessing": "6–7 business days",
      "filingFee": 40,
      "nameReservationFee": 15,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 20,
      "foreignQualification ": 90,
      "trademarkAndServiceMarkRegistration": 10,
      "annualReportFee": 15,
      "lateFilingPenalties": 15,
      "amendmentToArticlesOfOrganization": 15,
      "reinstatement": 40,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 10,
      "articlesOfDissolution": 10,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 0.50,\n  \"unit\": \"page\",\n  \"description\": \"$0.50 per page\",\n  \"explanation\": \"A fee of $0.50 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 15,
      "apostilleAndAuthenticationServices": 10,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 15,
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "KY",
      "value": "KY",
      "state": "Kentucky",
      "standartProcessing": "6–7 business days",
      "filingFee": 40,
      "nameReservationFee": 15,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 20,
      "foreignQualification ": 90,
      "trademarkAndServiceMarkRegistration": 10,
      "annualReportFee": 15,
      "lateFilingPenalties": 15,
      "amendmentToArticlesOfOrganization": 15,
      "reinstatement": 40,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 10,
      "articlesOfDissolution": 10,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 0.50,\n  \"unit\": \"page\",\n  \"description\": \"$0.50 per page\",\n  \"explanation\": \"A fee of $0.50 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 15,
      "apostilleAndAuthenticationServices": 10,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 15,
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "KY",
      "value": "KY",
      "state": "Kentucky",
      "standartProcessing": "5–10 business days",
      "filingFee": 8,
      "nameReservationFee": 15,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 20,
      "foreignQualification ": 90,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 15,
      "lateFilingPenalties": "None",
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "LA": {
    "id": "LA",
    "value": "LA",
    "label": "Louisiana",
    "field": "state",
    "privacyLevel": 3,
    "name": "Louisiana",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "LA",
      "value": "LA",
      "state": "Louisiana",
      "standartProcessing": "10–12 business days",
      "filingFee": 100,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "[30,50]",
      "certificateOfStatus": 20,
      "fictitiousNameDBARegistration": 75,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 35,
      "lateFilingPenalties": 30,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 75,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 30,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 100,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "LA",
      "value": "LA",
      "state": "Louisiana",
      "standartProcessing": "10–12 business days",
      "filingFee": 75,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "[30–50]",
      "certificateOfStatus": 20,
      "fictitiousNameDBARegistration": 75,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 35,
      "lateFilingPenalties": 30,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 75,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 30,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 100,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "LA",
      "value": "LA",
      "state": "Louisiana",
      "standartProcessing": "5–10 business days",
      "filingFee": 60,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 125,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 10,
      "lateFilingPenalties": "None",
      "amendmentToArticlesOfOrganization": 75,
      "reinstatement": 75,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "ME": {
    "id": "ME",
    "value": "ME",
    "label": "Maine",
    "field": "state",
    "privacyLevel": 3,
    "name": "Maine",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "ME",
      "value": "ME",
      "state": "Maine",
      "standartProcessing": "15–20 business days",
      "filingFee": 175,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "[50,100]",
      "certificateOfStatus": 30,
      "fictitiousNameDBARegistration": 125,
      "foreignQualification ": 250,
      "trademarkAndServiceMarkRegistration": 40,
      "annualReportFee": 85,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 150,
      "registeredAgentChange": 35,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 2,\n  \"unit\": \"page\",\n  \"description\": \"$2,00 per page\",\n  \"explanation\": \"A fee of $2.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 85,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "ME",
      "value": "ME",
      "state": "Maine",
      "standartProcessing": "15–20 business days",
      "filingFee": 145,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "[50–100]",
      "certificateOfStatus": 30,
      "fictitiousNameDBARegistration": 125,
      "foreignQualification ": 250,
      "trademarkAndServiceMarkRegistration": 40,
      "annualReportFee": 85,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 150,
      "registeredAgentChange": 35,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 2,\n  \"unit\": \"page\",\n  \"description\": \"$2.00 per page\",\n  \"explanation\": \"A fee of $2.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 85,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "ME",
      "value": "ME",
      "state": "Maine",
      "standartProcessing": "5–10 business days",
      "filingFee": 40,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 25,
      "lateFilingPenalties": "None",
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "MD": {
    "id": "MD",
    "value": "MD",
    "label": "Maryland",
    "field": "state",
    "privacyLevel": 3,
    "name": "Maryland",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "MD",
      "value": "MD",
      "state": "Maryland",
      "standartProcessing": "12–15 business days",
      "filingFee": 100,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": 50,
      "certificateOfStatus": 40,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 300,
      "lateFilingPenalties": 100,
      "amendmentToArticlesOfOrganization": 100,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 100,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 20,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 40,
      "UCCFilings": 20,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 300,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "MD",
      "value": "MD",
      "state": "Maryland",
      "standartProcessing": "12–15 business days",
      "filingFee": 120,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 50,
      "certificateOfStatus": 40,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 300,
      "lateFilingPenalties": 100,
      "amendmentToArticlesOfOrganization": 100,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 100,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 20,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 40,
      "UCCFilings": 20,
      "apostilleAndAuthenticationServices": "Varies",
      "annualFranchiseOrPrivilegeTaxes ": 300,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "MD",
      "value": "MD",
      "state": "Maryland",
      "standartProcessing": "5–10 business days",
      "filingFee": 100,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 25,
      "lateFilingPenalties": "None",
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "MA": {
    "id": "MA",
    "value": "MA",
    "label": "Massachusetts",
    "field": "state",
    "privacyLevel": 3,
    "name": "Massachusetts",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "MA",
      "value": "MA",
      "state": "Massachusetts",
      "standartProcessing": "10–12 business days",
      "filingFee": 500,
      "nameReservationFee": 30,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": 20,
      "certificateOfStatus": 15,
      "fictitiousNameDBARegistration": 65,
      "foreignQualification ": 500,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 500,
      "lateFilingPenalties": "{\"monthLate\":25}",
      "amendmentToArticlesOfOrganization": 100,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 100,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 35,
      "UCCFilings": 6,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 500,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "MA",
      "value": "MA",
      "state": "Massachusetts",
      "standartProcessing": "10–12 business days",
      "filingFee": 275,
      "nameReservationFee": 30,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 20,
      "certificateOfStatus": 15,
      "fictitiousNameDBARegistration": 65,
      "foreignQualification ": 500,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 500,
      "lateFilingPenalties": "{\n  \"lateFee\": 25,\n  \"lateFeeUnit\": \"month\",\n  \"description\": \"$25 per month late\",\n  \"explanation\": \"A late fee of $25 is applied for each month the payment is overdue.\"\n}\n",
      "amendmentToArticlesOfOrganization": 100,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 100,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 35,
      "UCCFilings": 6,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 500,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "MA",
      "value": "MA",
      "state": "Massachusetts",
      "standartProcessing": "10–15 business days",
      "filingFee": 35,
      "nameReservationFee": 30,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 125,
      "annualReportFee": 25,
      "lateFilingPenalties": 100,
      "amendmentToArticlesOfOrganization": 100,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 100,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 100,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 100,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "MI": {
    "id": "MI",
    "value": "MI",
    "label": "Michigan",
    "field": "state",
    "privacyLevel": 3,
    "name": "Michigan",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "MI",
      "value": "MI",
      "state": "Michigan",
      "standartProcessing": "10–12 business days",
      "filingFee": 50,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 50,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 25,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 100,
      "registeredAgentChange": 5,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 10,
      "articlesOfDissolution": 10,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 1,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "MI",
      "value": "MI",
      "state": "Michigan",
      "standartProcessing": "10–12 business days",
      "filingFee": 60,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 60,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 25,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 100,
      "registeredAgentChange": 5,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 10,
      "articlesOfDissolution": 10,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 1,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "MI",
      "value": "MI",
      "state": "Michigan",
      "standartProcessing": "10–15 business days",
      "filingFee": 20,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "{\"sameDay\":50,\"24h\":100}",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 20,
      "annualReportFee": 20,
      "lateFilingPenalties": 10,
      "amendmentToArticlesOfOrganization": 10,
      "reinstatement": 10,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 10,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 0,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 10,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "MN": {
    "id": "MN",
    "value": "MN",
    "label": "Minnesota",
    "field": "state",
    "privacyLevel": 3,
    "name": "Minnesota",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "MN",
      "value": "MN",
      "state": "Minnesota",
      "standartProcessing": "10–12 business days",
      "filingFee": 135,
      "nameReservationFee": 55,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 15,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 185,
      "trademarkAndServiceMarkRegistration": 70,
      "annualReportFee": 0,
      "lateFilingPenalties": 0,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 135,
      "registeredAgentChange": 35,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 35,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 5,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 40,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 0,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "MN",
      "value": "MN",
      "state": "Minnesota",
      "standartProcessing": "10–12 business days",
      "filingFee": 135,
      "nameReservationFee": 55,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 15,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 185,
      "trademarkAndServiceMarkRegistration": 70,
      "annualReportFee": 0,
      "lateFilingPenalties": 0,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 135,
      "registeredAgentChange": 35,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 35,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 5,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 40,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 0,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "MN",
      "value": "MN",
      "state": "Minnesota",
      "standartProcessing": "10–15 business days",
      "filingFee": 70,
      "nameReservationFee": 35,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 55,
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 50,
      "trademarkAndServiceMarkRegistration": 0,
      "annualReportFee": 25,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "MS": {
    "id": "MS",
    "value": "MS",
    "label": "Mississippi",
    "field": "state",
    "privacyLevel": 3,
    "name": "Mississippi",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "MS",
      "value": "MS",
      "state": "Mississippi",
      "standartProcessing": "6–7 business days",
      "filingFee": 50,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 25,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 250,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 25,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 30,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "MS",
      "value": "MS",
      "state": "Mississippi",
      "standartProcessing": "6–7 business days",
      "filingFee": 50,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 25,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 250,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 25,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 30,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "MS",
      "value": "MS",
      "state": "Mississippi",
      "standartProcessing": "10–15 business days",
      "filingFee": 50,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 50,
      "trademarkAndServiceMarkRegistration": 0,
      "annualReportFee": 50,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 50,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "MO": {
    "id": "MO",
    "value": "MO",
    "label": "Missouri",
    "field": "state",
    "privacyLevel": 3,
    "name": "Missouri",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "MO",
      "value": "MO",
      "state": "Missouri",
      "standartProcessing": "10–12 business days",
      "filingFee": 50,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 7,
      "foreignQualification ": 105,
      "trademarkAndServiceMarkRegistration": 55,
      "annualReportFee": 45,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 105,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 45,
      "mergerAndConversionFilings": 75,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 45,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "MO",
      "value": "MO",
      "state": "Missouri",
      "standartProcessing": "10–12 business days",
      "filingFee": 58,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 7,
      "foreignQualification ": 105,
      "trademarkAndServiceMarkRegistration": 55,
      "annualReportFee": 45,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 105,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 45,
      "mergerAndConversionFilings": 75,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": 1,
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 45,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "MO",
      "value": "MO",
      "state": "Missouri",
      "standartProcessing": "10–15 business days",
      "filingFee": 25,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 50,
      "trademarkAndServiceMarkRegistration": 0,
      "annualReportFee": 10,
      "lateFilingPenalties": 10,
      "amendmentToArticlesOfOrganization": 10,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 15,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 10,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "MT": {
    "id": "MT",
    "value": "MT",
    "label": "Montana",
    "field": "state",
    "privacyLevel": 3,
    "name": "Montana",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "MT",
      "value": "MT",
      "state": "Montana",
      "standartProcessing": "10–12 business days",
      "filingFee": 35,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "{\"24h\":20,\"1h\":100}",
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 20,
      "foreignQualification ": 70,
      "trademarkAndServiceMarkRegistration": 20,
      "annualReportFee": 20,
      "lateFilingPenalties": 15,
      "amendmentToArticlesOfOrganization": 15,
      "reinstatement": "{\n  \"baseFee\": 35,\n  \"lateFee\": 35,\n  \"lateFeeUnit\": \"per year\",\n  \"description\": \"$35 + $35/year late\",\n  \"explanation\": \"You pay $35 initially. If late, an additional $35 is charged for each year of delay.\"\n}\n",
      "registeredAgentChange": 15,
      "businessAddressUpdate": "No charge",
      "changeOfManagementOfficerFilingFees": 15,
      "articlesOfDissolution": 20,
      "mergerAndConversionFilings": 20,
      "certifiedCopyOfDocuments": 5,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 40,
      "apostilleAndAuthenticationServices": 25,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 35,
      "recommendationScore": 8,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "MT",
      "value": "MT",
      "state": "Montana",
      "standartProcessing": "10–12 business days",
      "filingFee": 35,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "{\"1h\":100,\"24h\":20}",
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 20,
      "foreignQualification ": 70,
      "trademarkAndServiceMarkRegistration": "Not specified",
      "annualReportFee": 20,
      "lateFilingPenalties": 15,
      "amendmentToArticlesOfOrganization": 15,
      "reinstatement": "{\n  \"baseFee\": 35,\n  \"lateFee\": 35,\n  \"lateFeeUnit\": \"year\",\n  \"description\": \"$35 base fee plus $35 per year late\",\n  \"explanation\": \"An initial fee of $35 is charged. If the payment is late, an additional $35 is added for each year of delay.\"\n}\n",
      "registeredAgentChange": 15,
      "businessAddressUpdate": "No charge",
      "changeOfManagementOfficerFilingFees": 15,
      "articlesOfDissolution": 20,
      "mergerAndConversionFilings": 20,
      "certifiedCopyOfDocuments": 5,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 40,
      "apostilleAndAuthenticationServices": 25,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 35,
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "MT",
      "value": "MT",
      "state": "Montana",
      "standartProcessing": "5–10 business days",
      "filingFee": 20,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 50,
      "trademarkAndServiceMarkRegistration": 20,
      "annualReportFee": 15,
      "lateFilingPenalties": 15,
      "amendmentToArticlesOfOrganization": 10,
      "reinstatement": 10,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 10,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 10,
      "certifiedCopyOfDocuments": "{\n  \"unitFee\": 0.25,\n  \"unit\": \"page\",\n  \"description\": \"$0.25 per page\",\n  \"explanation\": \"A fee of $0.25 is charged for each page.\"\n}\n",
      "copiesOfFiledDocuments": 10,
      "franchiseTaxFees": "Not required",
      "publicationRequirements": 10,
      "expeditedDocumentRetrieval": 10,
      "UCCFilings": "None",
      "apostilleAndAuthenticationServices": 10,
      "annualFranchiseOrPrivilegeTaxes ": "Varies by municipality",
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "NE": {
    "id": "NE",
    "value": "NE",
    "label": "Nebraska",
    "field": "state",
    "privacyLevel": 3,
    "name": "Nebraska",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "NE",
      "value": "NE",
      "state": "Nebraska",
      "standartProcessing": "10–12 business days",
      "filingFee": 100,
      "nameReservationFee": 30,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 13,
      "lateFilingPenalties": 30,
      "amendmentToArticlesOfOrganization": 30,
      "reinstatement": 30,
      "registeredAgentChange": 30,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 30,
      "articlesOfDissolution": 30,
      "mergerAndConversionFilings": 30,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Required (publication)",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 25,
      "apostilleAndAuthenticationServices": 10,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 30,
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "NE",
      "value": "NE",
      "state": "Nebraska",
      "standartProcessing": "10–12 business days",
      "filingFee": 100,
      "nameReservationFee": 30,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 13,
      "lateFilingPenalties": 30,
      "amendmentToArticlesOfOrganization": 30,
      "reinstatement": 30,
      "registeredAgentChange": 30,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 30,
      "articlesOfDissolution": 30,
      "mergerAndConversionFilings": 30,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Required (publication)",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 25,
      "apostilleAndAuthenticationServices": 10,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 30,
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "NE",
      "value": "NE",
      "state": "Nebraska",
      "standartProcessing": "5–10 business days",
      "filingFee": 25,
      "nameReservationFee": 30,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 25,
      "annualReportFee": "None",
      "lateFilingPenalties": "None",
      "amendmentToArticlesOfOrganization": 30,
      "reinstatement": 30,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "NV": {
    "id": "NV",
    "value": "NV",
    "label": "Nevada",
    "field": "state",
    "privacyLevel": 3,
    "name": "Nevada",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "NV",
      "value": "NV",
      "state": "Nevada",
      "standartProcessing": "10–12 business days",
      "filingFee": 75,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "{\"24h\":125,\"2h\":500,\"1h\":1000}",
      "certificateOfStatus": 50,
      "fictitiousNameDBARegistration": 20,
      "foreignQualification ": 75,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 150,
      "lateFilingPenalties": 75,
      "amendmentToArticlesOfOrganization": 60,
      "reinstatement": 75,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 75,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 30,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 100,
      "UCCFilings": 20,
      "apostilleAndAuthenticationServices": 200,
      "annualFranchiseOrPrivilegeTaxes ": "{\n  \"lateFee\": 75,\n  \"lateFeeUnit\": \"month\",\n  \"description\": \"$75 per month late\",\n  \"explanation\": \"An additional fee of $75 is charged for each month the payment is late.\"\n}\n",
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 9,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "NV",
      "value": "NV",
      "state": "Nevada",
      "standartProcessing": "10–12 business days",
      "filingFee": 75,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "{\"24h\":125,\"2h\":500,\"1h\":1000}",
      "certificateOfStatus": 50,
      "fictitiousNameDBARegistration": 20,
      "foreignQualification ": 425,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 350,
      "lateFilingPenalties": 75,
      "amendmentToArticlesOfOrganization": 60,
      "reinstatement": 75,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 75,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 30,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 100,
      "UCCFilings": 20,
      "apostilleAndAuthenticationServices": 200,
      "annualFranchiseOrPrivilegeTaxes ": "{\n  \"lateFee\": 75,\n  \"lateFeeUnit\": \"month\",\n  \"description\": \"$75 per month late\",\n  \"explanation\": \"A fee of $75 is charged for each month the payment is late.\"\n}\n",
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 8,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "NV",
      "value": "NV",
      "state": "Nevada",
      "standartProcessing": "5–10 business days",
      "filingFee": 50,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "{\"1h\":1000,\"2h\":500,\"24h\":125}",
      "certificateOfStatus": 50,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 50,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 50,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "NH": {
    "id": "NH",
    "value": "NH",
    "label": "New Hampshire",
    "field": "state",
    "privacyLevel": 3,
    "name": "New Hampshire",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "NH",
      "value": "NH",
      "state": "New Hampshire",
      "standartProcessing": "10–12 business days",
      "filingFee": 100,
      "nameReservationFee": 15,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 100,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 35,
      "reinstatement": 100,
      "registeredAgentChange": 15,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 35,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 35,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 100,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "NH",
      "value": "NH",
      "state": "New Hampshire",
      "standartProcessing": "10–12 business days",
      "filingFee": 100,
      "nameReservationFee": 15,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 100,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 35,
      "reinstatement": 100,
      "registeredAgentChange": 15,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 35,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 35,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 100,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "NH",
      "value": "NH",
      "state": "New Hampshire",
      "standartProcessing": "5–10 business days",
      "filingFee": 25,
      "nameReservationFee": 15,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 75,
      "annualReportFee": 25,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 75,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 75,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "NJ": {
    "id": "NJ",
    "value": "NJ",
    "label": "New Jersey",
    "field": "state",
    "privacyLevel": 3,
    "name": "New Jersey",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "NJ",
      "value": "NJ",
      "state": "New Jersey",
      "standartProcessing": "10–12 business days",
      "filingFee": 125,
      "nameReservationFee": 50,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "{\"sameDay\":25,\"2h\":500,\"1h\":1000}",
      "certificateOfStatus": 50,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 125,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 75,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 75,
      "reinstatement": 75,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 75,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 25,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 25,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 75,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "NJ",
      "value": "NJ",
      "state": "New Jersey",
      "standartProcessing": "10–12 business days",
      "filingFee": 125,
      "nameReservationFee": 50,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "{\"sameDay\":25,\"2h\":500,\"1h\":1000}",
      "certificateOfStatus": 50,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 125,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 75,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 75,
      "reinstatement": 75,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 75,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 25,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 25,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 75,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "NJ",
      "value": "NJ",
      "state": "New Jersey",
      "standartProcessing": "5–10 business days",
      "filingFee": 75,
      "nameReservationFee": 50,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "{\"1h\":1000,\"2h\":500,\"24h\":15}",
      "certificateOfStatus": 25,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 125,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 50,
      "lateFilingPenalties": 75,
      "amendmentToArticlesOfOrganization": 150,
      "reinstatement": 150,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 10,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 30,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "NM": {
    "id": "NM",
    "value": "NM",
    "label": "New Mexico",
    "field": "state",
    "privacyLevel": 4,
    "name": "New Mexico",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "NM",
      "value": "NM",
      "state": "New Mexico",
      "standartProcessing": "10–12 business days",
      "filingFee": 50,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 25,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": "Not specified",
      "annualReportFee": "None",
      "lateFilingPenalties": "None",
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 25,
      "apostilleAndAuthenticationServices": 10,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": "None",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 4
    },
    "Corporation": {
      "id": "NM",
      "value": "NM",
      "state": "New Mexico",
      "standartProcessing": "10–12 business days",
      "filingFee": 100,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 25,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": "Not specified",
      "annualReportFee": "None",
      "lateFilingPenalties": "None",
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 25,
      "apostilleAndAuthenticationServices": 10,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": "None",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 4
    },
    "Nonprofit": {
      "id": "NM",
      "value": "NM",
      "state": "New Mexico",
      "standartProcessing": "10–15 business days",
      "filingFee": 25,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 10,
      "annualReportFee": 10,
      "lateFilingPenalties": 30,
      "amendmentToArticlesOfOrganization": 200,
      "reinstatement": 10,
      "registeredAgentChange": 0,
      "businessAddressUpdate": 10,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 100,
      "mergerAndConversionFilings": 10,
      "certifiedCopyOfDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "copiesOfFiledDocuments": 0,
      "franchiseTaxFees": "Not required",
      "publicationRequirements": 25,
      "expeditedDocumentRetrieval": 10,
      "UCCFilings": "None",
      "apostilleAndAuthenticationServices": 10,
      "annualFranchiseOrPrivilegeTaxes ": "Varies by municipality",
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "NY": {
    "id": "NY",
    "value": "NY",
    "label": "New York",
    "field": "state",
    "privacyLevel": 3,
    "name": "New York",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "NY",
      "value": "NY",
      "state": "New York",
      "standartProcessing": "10–12 business days",
      "filingFee": 200,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "[25,150]",
      "certificateOfStatus": 25,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 250,
      "trademarkAndServiceMarkRegistration": "Varies by county",
      "annualReportFee": 9,
      "lateFilingPenalties": "[50–1,500]",
      "amendmentToArticlesOfOrganization": 60,
      "reinstatement": 60,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 60,
      "mergerAndConversionFilings": 125,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Required",
      "expeditedDocumentRetrieval": 75,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 9,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "NY",
      "value": "NY",
      "state": "New York",
      "standartProcessing": "10–12 business days",
      "filingFee": 125,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "[25–150]",
      "certificateOfStatus": 25,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 250,
      "trademarkAndServiceMarkRegistration": "Varies by county",
      "annualReportFee": 9,
      "lateFilingPenalties": "[50–1,500]",
      "amendmentToArticlesOfOrganization": 60,
      "reinstatement": 60,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 60,
      "mergerAndConversionFilings": 125,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Required",
      "expeditedDocumentRetrieval": 75,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 9,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "NY",
      "value": "NY",
      "state": "New York",
      "standartProcessing": "10–15 business days",
      "filingFee": 75,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 25,
      "certificateOfStatus": 25,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 135,
      "trademarkAndServiceMarkRegistration": 25,
      "annualReportFee": 25,
      "lateFilingPenalties": 30,
      "amendmentToArticlesOfOrganization": 30,
      "reinstatement": 30,
      "registeredAgentChange": 30,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 30,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "NC": {
    "id": "NC",
    "value": "NC",
    "label": "North Carolina",
    "field": "state",
    "privacyLevel": 3,
    "name": "North Carolina",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "NC",
      "value": "NC",
      "state": "North Carolina",
      "standartProcessing": "10–12 business days",
      "filingFee": 125,
      "nameReservationFee": 30,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "[100,200]",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 26,
      "foreignQualification ": 250,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 200,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 30,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 30,
      "mergerAndConversionFilings": 75,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 35,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 200,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "NC",
      "value": "NC",
      "state": "North Carolina",
      "standartProcessing": "10–12 business days",
      "filingFee": 125,
      "nameReservationFee": 30,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "[100–200]",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 26,
      "foreignQualification ": 250,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 200,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 30,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 30,
      "mergerAndConversionFilings": 75,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 35,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 200,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "NC",
      "value": "NC",
      "state": "North Carolina",
      "standartProcessing": "10–15 business days",
      "filingFee": 60,
      "nameReservationFee": 30,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 15,
      "certificateOfStatus": 15,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 125,
      "trademarkAndServiceMarkRegistration": 20,
      "annualReportFee": 20,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "ND": {
    "id": "ND",
    "value": "ND",
    "label": "North Dakota",
    "field": "state",
    "privacyLevel": 3,
    "name": "North Dakota",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "ND",
      "value": "ND",
      "state": "North Dakota",
      "standartProcessing": "10–12 business days",
      "filingFee": 135,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 20,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 135,
      "trademarkAndServiceMarkRegistration": 20,
      "annualReportFee": 50,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 20,
      "registeredAgentChange": 20,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 20,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 20,
      "apostilleAndAuthenticationServices": 10,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 50,
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "ND",
      "value": "ND",
      "state": "North Dakota",
      "standartProcessing": "10–12 business days",
      "filingFee": 100,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 20,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 135,
      "trademarkAndServiceMarkRegistration": 20,
      "annualReportFee": 50,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 20,
      "registeredAgentChange": 20,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 20,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 20,
      "apostilleAndAuthenticationServices": 10,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 50,
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "ND",
      "value": "ND",
      "state": "North Dakota",
      "standartProcessing": "10–15 business days",
      "filingFee": 40,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 10,
      "annualReportFee": 10,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 25,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "OH": {
    "id": "OH",
    "value": "OH",
    "label": "Ohio",
    "field": "state",
    "privacyLevel": 3,
    "name": "Ohio",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "OH",
      "value": "OH",
      "state": "Ohio",
      "standartProcessing": "10–12 business days",
      "filingFee": 99,
      "nameReservationFee": 39,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 99,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": "None",
      "lateFilingPenalties": "None",
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 5,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": 5,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": "None",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "OH",
      "value": "OH",
      "state": "Ohio",
      "standartProcessing": "10–12 business days",
      "filingFee": 99,
      "nameReservationFee": 39,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 99,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": "None",
      "lateFilingPenalties": "None",
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 5,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": 5,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": "None",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "OH",
      "value": "OH",
      "state": "Ohio",
      "standartProcessing": "10–15 business days",
      "filingFee": 50,
      "nameReservationFee": 39,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 5,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 125,
      "trademarkAndServiceMarkRegistration": 25,
      "annualReportFee": 25,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "OK": {
    "id": "OK",
    "value": "OK",
    "label": "Oklahoma",
    "field": "state",
    "privacyLevel": 3,
    "name": "Oklahoma",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "OK",
      "value": "OK",
      "state": "Oklahoma",
      "standartProcessing": "10–12 business days",
      "filingFee": 100,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 20,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 300,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 25,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 150,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 35,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "OK",
      "value": "OK",
      "state": "Oklahoma",
      "standartProcessing": "10–12 business days",
      "filingFee": 50,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 20,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 300,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 25,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 150,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 35,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "OK",
      "value": "OK",
      "state": "Oklahoma",
      "standartProcessing": "5–10 business days",
      "filingFee": 25,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 25,
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 65,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 25,
      "annualReportFee": 50,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 25,
      "registeredAgentChange": 0,
      "businessAddressUpdate": 50,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 100,
      "mergerAndConversionFilings": 10,
      "certifiedCopyOfDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "copiesOfFiledDocuments": "[15–65]",
      "franchiseTaxFees": "Not required",
      "publicationRequirements": 25,
      "expeditedDocumentRetrieval": 10,
      "UCCFilings": "None",
      "apostilleAndAuthenticationServices": 50,
      "annualFranchiseOrPrivilegeTaxes ": "Varies by municipality",
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "OR": {
    "id": "OR",
    "value": "OR",
    "label": "Oregon",
    "field": "state",
    "privacyLevel": 3,
    "name": "Oregon",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "OR",
      "value": "OR",
      "state": "Oregon",
      "standartProcessing": "10–12 business days",
      "filingFee": 100,
      "nameReservationFee": 50,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 275,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 100,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 100,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 40,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 100,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "OR",
      "value": "OR",
      "state": "Oregon",
      "standartProcessing": "10–12 business days",
      "filingFee": 100,
      "nameReservationFee": 50,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 275,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 100,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 100,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 40,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 100,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "OR",
      "value": "OR",
      "state": "Oregon",
      "standartProcessing": "5–10 business days",
      "filingFee": 50,
      "nameReservationFee": 100,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 10,
      "certificateOfStatus": 50,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 50,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 0,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 0,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 10,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 50,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "PA": {
    "id": "PA",
    "value": "PA",
    "label": "Pennsylvania",
    "field": "state",
    "privacyLevel": 3,
    "name": "Pennsylvania",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "PA",
      "value": "PA",
      "state": "Pennsylvania",
      "standartProcessing": "10–12 business days",
      "filingFee": 125,
      "nameReservationFee": 70,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 40,
      "fictitiousNameDBARegistration": 70,
      "foreignQualification ": 250,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 7,
      "lateFilingPenalties": 15,
      "amendmentToArticlesOfOrganization": 70,
      "reinstatement": 35,
      "registeredAgentChange": 70,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 70,
      "articlesOfDissolution": 150,
      "mergerAndConversionFilings": 125,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 7,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "PA",
      "value": "PA",
      "state": "Pennsylvania",
      "standartProcessing": "10–12 business days",
      "filingFee": 125,
      "nameReservationFee": 70,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 40,
      "fictitiousNameDBARegistration": 70,
      "foreignQualification ": 250,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 7,
      "lateFilingPenalties": 15,
      "amendmentToArticlesOfOrganization": 70,
      "reinstatement": 35,
      "registeredAgentChange": 70,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 70,
      "articlesOfDissolution": 150,
      "mergerAndConversionFilings": 125,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 7,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "PA",
      "value": "PA",
      "state": "Pennsylvania",
      "standartProcessing": "5–10 business days",
      "filingFee": 125,
      "nameReservationFee": 70,
      "nameAvailabilitySearchFee": 15,
      "rushFilings": 40,
      "certificateOfStatus": 70,
      "fictitiousNameDBARegistration": 0,
      "foreignQualification ": 125,
      "trademarkAndServiceMarkRegistration": 0,
      "annualReportFee": 0,
      "lateFilingPenalties": 70,
      "amendmentToArticlesOfOrganization": 70,
      "reinstatement": 70,
      "registeredAgentChange": 5,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 70,
      "articlesOfDissolution": 70,
      "mergerAndConversionFilings": 40,
      "certifiedCopyOfDocuments": 40,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 0.25,\n  \"unit\": \"name\",\n  \"description\": \"$0.25 per name\",\n  \"explanation\": \"A fee of $0.25 is charged for each name.\"\n}\n",
      "franchiseTaxFees": 0,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 70,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 0,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "RI": {
    "id": "RI",
    "value": "RI",
    "label": "Rhode Island",
    "field": "state",
    "privacyLevel": 3,
    "name": "Rhode Island",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "RI",
      "value": "RI",
      "state": "Rhode Island",
      "standartProcessing": "10–12 business days",
      "filingFee": 150,
      "nameReservationFee": 50,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 25,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 50,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 50,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 400,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 35,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": 400,
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "RI",
      "value": "RI",
      "state": "Rhode Island",
      "standartProcessing": "10–12 business days",
      "filingFee": 230,
      "nameReservationFee": 50,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 25,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 50,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 50,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 400,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 35,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": 400,
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "RI",
      "value": "RI",
      "state": "Rhode Island",
      "standartProcessing": "5–10 business days",
      "filingFee": 35,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "[20–22]",
      "certificateOfStatus": 50,
      "fictitiousNameDBARegistration": 90,
      "foreignQualification ": 90,
      "trademarkAndServiceMarkRegistration": 20,
      "annualReportFee": 25,
      "lateFilingPenalties": 10,
      "amendmentToArticlesOfOrganization": 10,
      "reinstatement": 10,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 10,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 20,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 90,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 20,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "SC": {
    "id": "SC",
    "value": "SC",
    "label": "South Carolina",
    "field": "state",
    "privacyLevel": 3,
    "name": "South Carolina",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "SC",
      "value": "SC",
      "state": "South Carolina",
      "standartProcessing": "10–12 business days",
      "filingFee": 110,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 110,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 25,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 110,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 35,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "SC",
      "value": "SC",
      "state": "South Carolina",
      "standartProcessing": "10–12 business days",
      "filingFee": 135,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 110,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 25,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 110,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 35,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "SC",
      "value": "SC",
      "state": "South Carolina",
      "standartProcessing": "5–10 business days",
      "filingFee": 25,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 10,
      "certificateOfStatus": 50,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 50,
      "trademarkAndServiceMarkRegistration": 0,
      "annualReportFee": 0,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 10,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 50,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "SD": {
    "id": "SD",
    "value": "SD",
    "label": "South Dakota",
    "field": "state",
    "privacyLevel": 3,
    "name": "South Dakota",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "SD",
      "value": "SD",
      "state": "South Dakota",
      "standartProcessing": "10–12 business days",
      "filingFee": 150,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 20,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 765,
      "trademarkAndServiceMarkRegistration": "Not specified",
      "annualReportFee": 50,
      "lateFilingPenalties": "Not specified",
      "amendmentToArticlesOfOrganization": 60,
      "reinstatement": 150,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 20,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 50,
      "recommendationScore": 8,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "SD",
      "value": "SD",
      "state": "South Dakota",
      "standartProcessing": "10–12 business days",
      "filingFee": 150,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 20,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 765,
      "trademarkAndServiceMarkRegistration": "Not specified",
      "annualReportFee": 50,
      "lateFilingPenalties": "Not specified",
      "amendmentToArticlesOfOrganization": 60,
      "reinstatement": 150,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": "Not specified",
      "UCCFilings": 20,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 50,
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "SD",
      "value": "SD",
      "state": "South Dakota",
      "standartProcessing": "5–10 business days",
      "filingFee": 30,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 50,
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 10,
      "annualReportFee": 50,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "$2/page",
      "franchiseTaxFees": 25,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "TN": {
    "id": "TN",
    "value": "TN",
    "label": "Tennessee",
    "field": "state",
    "privacyLevel": 3,
    "name": "Tennessee",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "TN",
      "value": "TN",
      "state": "Tennessee",
      "standartProcessing": "10–12 business days",
      "filingFee": 300,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 20,
      "fictitiousNameDBARegistration": 20,
      "foreignQualification ": "[300–3,000]",
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 300,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 60,
      "reinstatement": 300,
      "registeredAgentChange": 20,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 60,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 20,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 20,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 300,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 8,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "TN",
      "value": "TN",
      "state": "Tennessee",
      "standartProcessing": "10–12 business days",
      "filingFee": 100,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 20,
      "fictitiousNameDBARegistration": 20,
      "foreignQualification ": "[300–3,000]",
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 300,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 60,
      "reinstatement": 300,
      "registeredAgentChange": 20,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 60,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 20,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 20,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 300,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "TN",
      "value": "TN",
      "state": "Tennessee",
      "standartProcessing": "5–10 business days",
      "filingFee": 100,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 20,
      "certificateOfStatus": 20,
      "fictitiousNameDBARegistration": 20,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 20,
      "annualReportFee": 20,
      "lateFilingPenalties": 20,
      "amendmentToArticlesOfOrganization": 20,
      "reinstatement": 20,
      "registeredAgentChange": 20,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 20,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 20,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 20,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "TX": {
    "id": "TX",
    "value": "TX",
    "label": "Texas",
    "field": "state",
    "privacyLevel": 3,
    "name": "Texas",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "TX",
      "value": "TX",
      "state": "Texas",
      "standartProcessing": "10–12 business days",
      "filingFee": 300,
      "nameReservationFee": 40,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "{\"perDocument\":25}",
      "certificateOfStatus": 15,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 750,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": "None",
      "lateFilingPenalties": "Not specified",
      "amendmentToArticlesOfOrganization": 150,
      "reinstatement": 300,
      "registeredAgentChange": 15,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 150,
      "articlesOfDissolution": 300,
      "mergerAndConversionFilings": 300,
      "certifiedCopyOfDocuments": 15,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 15,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 9,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "TX",
      "value": "TX",
      "state": "Texas",
      "standartProcessing": "10–12 business days",
      "filingFee": 300,
      "nameReservationFee": 40,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "{\"perDocument\":25}",
      "certificateOfStatus": 15,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 750,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": "None",
      "lateFilingPenalties": "Not specified",
      "amendmentToArticlesOfOrganization": 150,
      "reinstatement": 300,
      "registeredAgentChange": 15,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 150,
      "articlesOfDissolution": 300,
      "mergerAndConversionFilings": 300,
      "certifiedCopyOfDocuments": 15,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 15,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "TX",
      "value": "TX",
      "state": "Texas",
      "standartProcessing": "5–10 business days",
      "filingFee": 25,
      "nameReservationFee": 40,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 25,
      "certificateOfStatus": 15,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": "{\n  \"fee\": 5,\n  \"interval\": 4,\n  \"intervalUnit\": \"years\",\n  \"description\": \"$5 every 4 years\",\n  \"explanation\": \"A recurring fee of $5 is charged once every 4 years.\"\n}\n",
      "annualReportFee": "{\n  \"fee\": 1,\n  \"interval\": 1,\n  \"intervalUnit\": \"month\",\n  \"description\": \"$1 per month\",\n  \"explanation\": \"A recurring fee of $1 is charged every month.\"\n}\n",
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 5,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 50,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 5,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "UT": {
    "id": "UT",
    "value": "UT",
    "label": "Utah",
    "field": "state",
    "privacyLevel": 3,
    "name": "Utah",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "UT",
      "value": "UT",
      "state": "Utah",
      "standartProcessing": "10–12 business days",
      "filingFee": 54,
      "nameReservationFee": 22,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 12,
      "fictitiousNameDBARegistration": 22,
      "foreignQualification ": 70,
      "trademarkAndServiceMarkRegistration": 22,
      "annualReportFee": 20,
      "lateFilingPenalties": 10,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 54,
      "registeredAgentChange": 15,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 20,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 8,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "UT",
      "value": "UT",
      "state": "Utah",
      "standartProcessing": "10–12 business days",
      "filingFee": 59,
      "nameReservationFee": 22,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 12,
      "fictitiousNameDBARegistration": 22,
      "foreignQualification ": 70,
      "trademarkAndServiceMarkRegistration": 22,
      "annualReportFee": 20,
      "lateFilingPenalties": 10,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 54,
      "registeredAgentChange": 15,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 20,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "UT",
      "value": "UT",
      "state": "Utah",
      "standartProcessing": "5–10 business days",
      "filingFee": 70,
      "nameReservationFee": 22,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 25,
      "certificateOfStatus": 12,
      "fictitiousNameDBARegistration": 18,
      "foreignQualification ": 90,
      "trademarkAndServiceMarkRegistration": 18,
      "annualReportFee": 10,
      "lateFilingPenalties": 17,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 13,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 90,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 18,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "VT": {
    "id": "VT",
    "value": "VT",
    "label": "Vermont",
    "field": "state",
    "privacyLevel": 3,
    "name": "Vermont",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "VT",
      "value": "VT",
      "state": "Vermont",
      "standartProcessing": "10–12 business days",
      "filingFee": 125,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "Not available",
      "certificateOfStatus": 25,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 125,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 35,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 50,
      "reinstatement": 125,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 50,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 50,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 35,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "VT",
      "value": "VT",
      "state": "Vermont",
      "standartProcessing": "10–12 business days",
      "filingFee": 125,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not available",
      "certificateOfStatus": 25,
      "fictitiousNameDBARegistration": 50,
      "foreignQualification ": 125,
      "trademarkAndServiceMarkRegistration": 20,
      "annualReportFee": 35,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 125,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 35,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 35,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "VT",
      "value": "VT",
      "state": "Vermont",
      "standartProcessing": "5–10 business days",
      "filingFee": 125,
      "nameReservationFee": 35,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 25,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 20,
      "annualReportFee": 25,
      "lateFilingPenalties": 20,
      "amendmentToArticlesOfOrganization": 20,
      "reinstatement": 20,
      "registeredAgentChange": 20,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 20,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 20,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 20,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "VA": {
    "id": "VA",
    "value": "VA",
    "label": "Virginia",
    "field": "state",
    "privacyLevel": 3,
    "name": "Virginia",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "VA",
      "value": "VA",
      "state": "Virginia",
      "standartProcessing": "10–12 business days",
      "filingFee": 100,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "{\"nextDay\":50,\"sameDay\":200}",
      "certificateOfStatus": 6,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 50,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 6,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 20,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "VA",
      "value": "VA",
      "state": "Virginia",
      "standartProcessing": "10–12 business days",
      "filingFee": 75,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "{\"nextDay\":50,\"sameDay\":200}",
      "certificateOfStatus": 6,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 50,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 100,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 6,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 20,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "VA",
      "value": "VA",
      "state": "Virginia",
      "standartProcessing": "10–12 business days",
      "filingFee": 75,
      "nameReservationFee": 10,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 50,
      "certificateOfStatus": 6,
      "fictitiousNameDBARegistration": 10,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 30,
      "annualReportFee": 25,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 50,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 50,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 50,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "WA": {
    "id": "WA",
    "value": "WA",
    "label": "Washington",
    "field": "state",
    "privacyLevel": 3,
    "name": "Washington",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "WA",
      "value": "WA",
      "state": "Washington",
      "standartProcessing": "10–12 business days",
      "filingFee": 180,
      "nameReservationFee": 30,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": 50,
      "certificateOfStatus": 20,
      "fictitiousNameDBARegistration": 5,
      "foreignQualification ": 200,
      "trademarkAndServiceMarkRegistration": 55,
      "annualReportFee": 70,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 30,
      "reinstatement": 140,
      "registeredAgentChange": 0,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 30,
      "articlesOfDissolution": 30,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 20,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 10,
      "UCCFilings": 15,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 70,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "WA",
      "value": "WA",
      "state": "Washington",
      "standartProcessing": "10–12 business days",
      "filingFee": 180,
      "nameReservationFee": 30,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 50,
      "certificateOfStatus": 20,
      "fictitiousNameDBARegistration": 5,
      "foreignQualification ": 200,
      "trademarkAndServiceMarkRegistration": 55,
      "annualReportFee": 70,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 30,
      "reinstatement": 140,
      "registeredAgentChange": 0,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 30,
      "articlesOfDissolution": 30,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 20,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 10,
      "UCCFilings": 15,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 70,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "WA",
      "value": "WA",
      "state": "Washington",
      "standartProcessing": "10–12 business days",
      "filingFee": 60,
      "nameReservationFee": 20,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 50,
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 40,
      "trademarkAndServiceMarkRegistration": 10,
      "annualReportFee": 25,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 25,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 40,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 40,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "WV": {
    "id": "WV",
    "value": "WV",
    "label": "West Virginia",
    "field": "state",
    "privacyLevel": 3,
    "name": "West Virginia",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "WV",
      "value": "WV",
      "state": "West Virginia",
      "standartProcessing": "10–12 business days",
      "filingFee": 100,
      "nameReservationFee": 15,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": "{\"24h\":25,\"2h\":250,\"1h\":500}",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 25,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 100,
      "registeredAgentChange": 15,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 15,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 20,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "WV",
      "value": "WV",
      "state": "West Virginia",
      "standartProcessing": "10–12 business days",
      "filingFee": 100,
      "nameReservationFee": 15,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "{\"24h\":25,\"2h\":250,\"1h\":500}",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 150,
      "trademarkAndServiceMarkRegistration": 50,
      "annualReportFee": 25,
      "lateFilingPenalties": 50,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 100,
      "registeredAgentChange": 15,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 15,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 20,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 5,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "WV",
      "value": "WV",
      "state": "West Virginia",
      "standartProcessing": "10–12 business days",
      "filingFee": 25,
      "nameReservationFee": 15,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "{\"1h\":500,\"2h\":250,\"24h\":25}",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 50,
      "trademarkAndServiceMarkRegistration": 25,
      "annualReportFee": 25,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 25,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 50,
      "mergerAndConversionFilings": 100,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "franchiseTaxFees": 50,
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 25,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  },
  "WI": {
    "id": "WI",
    "value": "WI",
    "label": "Wisconsin",
    "field": "state",
    "privacyLevel": 3,
    "name": "Wisconsin",
    "annualRequirements": "[\"Annual Report\"]",
    "LLC": {
      "id": "WI",
      "value": "WI",
      "state": "Wisconsin",
      "standartProcessing": "10–12 business days",
      "filingFee": 130,
      "nameReservationFee": 15,
      "nameAvailabilitySearchFee": "Included in reservation",
      "rushFilings": 25,
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 15,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 15,
      "annualReportFee": 25,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 40,
      "reinstatement": 100,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 20,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "",
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Corporation": {
      "id": "WI",
      "value": "WI",
      "state": "Wisconsin",
      "standartProcessing": "10–12 business days",
      "filingFee": 100,
      "nameReservationFee": 15,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": 25,
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 15,
      "foreignQualification ": 100,
      "trademarkAndServiceMarkRegistration": 15,
      "annualReportFee": 25,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 40,
      "reinstatement": 100,
      "registeredAgentChange": 10,
      "businessAddressUpdate": 0,
      "changeOfManagementOfficerFilingFees": 25,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 10,
      "copiesOfFiledDocuments": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1.00 per page\",\n  \"explanation\": \"A fee of $1.00 is charged for each page.\"\n}\n",
      "franchiseTaxFees": "None",
      "publicationRequirements": "Not required",
      "expeditedDocumentRetrieval": 20,
      "UCCFilings": 10,
      "apostilleAndAuthenticationServices": "None",
      "annualFranchiseOrPrivilegeTaxes ": 25,
      "lateOrMissedPaymentPenalties": "Varies by municipality",
      "recommendationScore": 6,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 3
    },
    "Nonprofit": {
      "id": "WI",
      "value": "WI",
      "state": "Wisconsin",
      "standartProcessing": "10–12 business days",
      "filingFee": 35,
      "nameReservationFee": 25,
      "nameAvailabilitySearchFee": "Included",
      "rushFilings": "Not specified",
      "certificateOfStatus": 10,
      "fictitiousNameDBARegistration": 25,
      "foreignQualification ": 25,
      "trademarkAndServiceMarkRegistration": 25,
      "annualReportFee": 0,
      "lateFilingPenalties": 25,
      "amendmentToArticlesOfOrganization": 25,
      "reinstatement": 25,
      "registeredAgentChange": 25,
      "businessAddressUpdate": 25,
      "changeOfManagementOfficerFilingFees": 0,
      "articlesOfDissolution": 25,
      "mergerAndConversionFilings": 50,
      "certifiedCopyOfDocuments": 100,
      "copiesOfFiledDocuments": 10,
      "franchiseTaxFees": "{\n  \"unitFee\": 1,\n  \"unit\": \"page\",\n  \"description\": \"$1 per page\",\n  \"explanation\": \"A fee of $1 is charged for each page.\"\n}\n",
      "publicationRequirements": 25,
      "expeditedDocumentRetrieval": "Not required",
      "UCCFilings": 25,
      "apostilleAndAuthenticationServices": 10,
      "annualFranchiseOrPrivilegeTaxes ": "None",
      "lateOrMissedPaymentPenalties": 25,
      "recommendationScore": 7,
      "annualRequirements": "[\"Annual Report\"]",
      "privacyLevel": 0
    }
  }
}
